import { casinos } from '../../../mocks/casinos';

export default function PromoCodeSection() {
  const copyToClipboard = (code: string, casinoName: string) => {
    navigator.clipboard.writeText(code);
    const button = document.getElementById(`copy-${casinoName}`);
    if (button) {
      const originalText = button.innerHTML;
      button.innerHTML = '<i class="ri-check-line mr-2"></i>Скопировано!';
      setTimeout(() => {
        button.innerHTML = originalText;
      }, 2000);
    }
  };

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Промокоды для всех казино</h2>
          <p className="text-gray-400 text-lg">Используйте промокод <span className="text-[#d4af37] font-bold">R2D2</span> для получения эксклюзивных бонусов</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {casinos.map((casino, index) => (
            <div 
              key={casino.id} 
              className="bg-[#242429] rounded-2xl p-6 border-2 border-dashed border-[#d4af37] hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-[#1a1a1f] p-2 flex items-center justify-center flex-shrink-0">
                  <img src={casino.logo} alt={casino.name} className="w-full h-full object-contain" />
                </div>
                <h3 className="text-xl font-bold">{casino.name}</h3>
              </div>

              <div className="bg-[#1a1a1f] rounded-xl p-4 mb-4">
                <div className="text-center">
                  <div className="text-sm text-gray-400 mb-2">Промокод:</div>
                  <div className="text-3xl font-mono font-bold text-[#d4af37] tracking-wider">
                    {casino.promoCode}
                  </div>
                </div>
              </div>

              <button
                id={`copy-${casino.name}`}
                onClick={() => copyToClipboard(casino.promoCode, casino.name)}
                className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-semibold py-3 px-4 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-file-copy-line"></i>
                Скопировать
              </button>

              <p className="text-sm text-gray-400 mt-4 text-center">{casino.bonusDescription}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}